<div *ngIf="ready" class="ManageContactGroup" [formGroup]="inputForm">
  <p>Please select any option for group {{ contactGroup.group_name }}</p>
  <div>
    <mat-radio-group
      aria-label="Select an user type"
      class="ManageContactGroup__options"
      formControlName="option"
      (change)="optionsChange()">
      <mat-radio-button *ngFor="let option of options" [value]="option">{{
        getOptionValue(option)
      }}</mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="mt-3" *ngIf="option && option.valid && option.value === 'rename'">
    <div class="d-flex justify-content-between align-items-center">
      <span>Enter group name</span>
      <app-text-field
        label="Group name"
        formControlName="group_name"></app-text-field>
    </div>
  </div>
  <div class="mt-3" *ngIf="option && option.valid && option.value === 'reset'">
    <mat-radio-group
      aria-label="Select an option"
      class="ManageContactGroup__options ManageContactGroup__options__with-padding"
      formControlName="reset_option">
      <mat-radio-button [value]="0"
        >Reset contacts without replies to email position 1</mat-radio-button
      >
      <mat-radio-button [value]="1"
        >Reset all contacts to email position 1 and reset all
        replies</mat-radio-button
      >
    </mat-radio-group>
  </div>
  <div class="mt-3" *ngIf="option && option.valid && option.value === 'merge'">
    <app-select
      formControlName="group_id"
      label="Select group to merge"
      [items]="contactGroupsList"></app-select>
  </div>
  <div
    class="mt-3"
    *ngIf="option && option.valid && option.value === 'download'">
    <app-select
      formControlName="download_format"
      label="Select format"
      [items]="formats"></app-select>
  </div>
</div>
